import { render } from "./contactoSeccion.vue?vue&type=template&id=986bf2c2&scoped=true"
const script = {}

import "./contactoSeccion.vue?vue&type=style&index=0&id=986bf2c2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-986bf2c2"]])

export default __exports__